
<div *ngIf="!hosts" class="v-center">
  <app-spinner class="large"></app-spinner>
</div>

<div *ngIf="hosts">
  <ul class="image-list image-list-nine-sixteen hosts">
    <li class="host" *ngFor="let host of hosts" [responsiveBackgroundImage]="host.headshot">
      <a routerLink="/hosts/{{host.id}}">
        <div>
          <h2>{{host.name}}</h2>
          <summary>
            {{host.summary}} This is test text. 
          </summary>
        </div>
      </a>
    </li>
  </ul>
</div>